import RecommendedDomains from "./RecommendedDomains";

export default RecommendedDomains;
